export default __webpack_public_path__ + "static/resume-98d370c077606af425923965407e990f.pdf";